import { makeStyles } from '@material-ui/core/styles';
import tinyColor from 'tinycolor2';
// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var handleColor = function (color, theme) {
    var primary = (theme === null || theme === void 0 ? void 0 : theme.primaryMain) || theme.palette.primary.main;
    var secondary = (theme === null || theme === void 0 ? void 0 : theme.secondaryMain) || theme.palette.secondary.main;
    switch (color) {
        case 'primary':
            return primary;
        case 'secondary':
            return secondary;
        default:
            return tinyColor(color).isValid() ? color : primary;
    }
};
// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var numberInputFieldStyles = makeStyles(function (theme) { return ({
    inputRoot: function (_a) {
        var color = _a.color;
        var inputColor = handleColor(color, theme);
        return {
            height: '100%',
            '& input': {
                paddingLeft: 10,
            },
            '& label': {
                paddingLeft: 10,
            },
            '& .MuiInputBase-root': {
                fontSize: 'inherit',
            },
            // Base Input overrides
            '& label:not(.Mui-error):not(.Mui-disabled)': {
                '&.MuiFormLabel-filled': {
                    color: inputColor,
                },
                '&.Mui-focused': {
                    color: inputColor,
                },
            },
            '& .MuiInput-underline:not(.Mui-error):not(.Mui-disabled)': {
                '&:hover': {
                    '&:before': {
                        borderBottomColor: inputColor,
                        borderWidth: '1px',
                    },
                },
                '&:after': {
                    borderBottomColor: inputColor,
                },
            },
            // Error overrides
            '& label.Mui-error': {
                color: theme.alert,
            },
            '& .MuiInput-underline.Mui-error': {
                '&:hover': {
                    '&:before': {
                        borderBottomColor: theme.alert,
                    },
                },
                '&:after': {
                    borderBottomColor: theme.alert,
                },
            },
            // Disabled overrides
            '& .Mui-disabled': {
                '&:before': {
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'currentColor',
                },
            },
            // Icon colors
            '& .MuiInput-root:not(.Mui-error):not(.Mui-disabled) svg': {
                fill: theme.infoMain,
            },
            '& .MuiInput-root.Mui-error svg': {
                fill: theme.alert,
            },
        };
    },
    helper: {
        color: theme.palesky,
        paddingLeft: 10,
        '&.Mui-error': {
            color: theme.alert,
        },
    },
}); });
